"use client";
import { APP_ROUTES } from "@/constants/routes";
import { User } from "@/models/user";
import { Box } from "@mui/material";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";

interface SubscriptionProps {
  isViewBySubscription?: boolean;
  user?: User;
  locale?: string;
}

const Subscription = function Subscription({
  isViewBySubscription,
  user,
  locale,
}: SubscriptionProps) {
  const [currentPath, setCurrentPath] = useState<string>("");
  const pathName = usePathname();
  const t = useTranslations("messages");
  const router = useRouter();
  const containerRef = React.useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handlePathChange = () => {
      const path =
        window.location.pathname +
        window.location.search +
        window.location.hash;
      setCurrentPath(path);
    };
    handlePathChange();
  }, [pathName]);

  if ((user?.license && !user?.license?.isOutOfDate) || isViewBySubscription) {
    return (
      <Box
        ref={containerRef}
        sx={{
          display: "none",
        }}
      ></Box>
    );
  }

  return (
    <Box className="flex justify-center mt-[16px]">
      <Box
        className="bg-ciBlue_light_4 p-4 md:p-6 rounded lg:flex-1 w-full max-w-2xl"
        ref={containerRef}
      >
        <Box className="bg-white p-4 md:p-6 rounded-lg grid gap-6 md:gap-8">
          <Box className="grid gap-2">
            <span
              translation-key="report_detail_subscribe"
              className="text-ciBlue_900 font-semibold text-xl md:text-2xl/6"
            >
              {t("report_detail_subscribe")}
            </span>
            <span
              translation-key="report_detail_subscribe_description"
              className="text-eerieBlack font-medium text-sm md:text-base/6"
            >
              {t("report_detail_subscribe_description")}
            </span>
          </Box>
          <Box className="gap-2 grid">
            <Box>
              <Link
                href={APP_ROUTES(locale as any).PRICING.to}
                className="!no-underline rounded-sm text-center !bg-ciBlue_900 !px-4 md:!px-6 !py-1 !gap-2 !grid w-full lg:!w-2/3 report-subscribe-button-link"
              >
                <Box className="py-1 grid">
                  <span
                    translation-key="report_subscribe_notice_button_title"
                    className="text-white font-semibold text-sm md:text-base/6 normal-case"
                  >
                    {t("report_subscribe_notice_button_title")}
                  </span>
                </Box>
              </Link>
            </Box>
            {!user && (
              <Box>
                <span
                  translation-key="report_detail_already_member"
                  className="font-medium text-sm md:text-base/6 normal-case text-eerieBlack"
                >
                  {t("report_detail_already_member")}{" "}
                  <Link
                    href={`${APP_ROUTES(locale as any).LOGIN.to}?redirect=${currentPath}`}
                    className="font-semibold hover:!underline text-ciBlue_900 cursor-pointer no-underline report-subscribe-sign-in-link"
                    translation-key="sign_in_btn"
                  >
                    {t("sign_in_btn")}
                  </Link>
                </span>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Subscription;
